<template>
  <div class="cadfm-container-horizontal">



    <PartTable v-show="$route.params.view == 'PartTable'"  :lang="lang.PartManager.PartTable">
    </PartTable>
    <PartNew v-if="$route.params.view == 'PartNew'"  :lang="lang.PartManager.PartNew">
    </PartNew>
    <PartDetails v-if="$route.params.view == 'PartDetails'" 
      :lang="lang.PartManager.PartDetails"></PartDetails>
    <PartDerive v-if="$route.params.view == 'PartDerive'"
      :lang="lang.PartManager.PartDerive"></PartDerive>
    <PartSearch v-if="$route.params.view == 'PartSearch'" 
      :lang="lang.PartManager.PartSearch"></PartSearch>
    <Categories v-if="$route.params.view == 'Categories'" 
      :lang="lang.PartManager.Categories"></Categories>
    <Properties v-if="$route.params.view == 'Properties'" 
      :lang="lang.PartManager.Properties"></Properties>
    <PartImport v-if="$route.params.view == 'PartImport'" 
      :lang="lang.PartManager.PartImport"></PartImport>
    <PartAssembly v-if="$route.params.view == 'PartAssembly'" 
      :lang="lang.PartManager.PartAssembly"></PartAssembly>
    <PartPhysicals v-if="$route.params.view == 'PartPhysicals'" 
      :lang="lang.PartManager.PartPhysicals"></PartPhysicals>
    <UL v-if="$route.params.view == 'UL'" 
      :lang="lang.PartManager.UL"></UL>
  </div>
</template>

<script>


import PartTable from '@/components/PartManager/Views/PartTable'
import PartNew from '@/components/PartManager/Views/PartNew'
import PartDetails from '@/components/PartManager/Views/PartDetails'
import PartDerive from '@/components/PartManager/Views/PartDerive'
import PartSearch from '@/components/PartManager/Views/PartSearch'
import Categories from '@/components/PartManager/Views/Categories'
import Properties from '@/components/PartManager/Views/Properties'
import PartImport from '@/components/PartManager/Views/PartImport'
import PartAssembly from '@/components/PartManager/Views/PartAssembly'
import PartPhysicals from '@/components/PartManager/Views/PartPhysicals'
import UL from '@/components/PartManager/Views/UL'

//import Left from '@/components/PartManager/Left/Left'
//import Right from '@/components/PartManager/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'PartManager',
  components:{
    PartTable,
    PartNew,
    PartDetails,
    PartDerive,
    PartSearch,
    Categories,
    Properties,
    PartImport,
    PartAssembly,
    PartPhysicals,
    UL
  },
  props: {
    lang: Object
  },
  data () {
    return {
      sectionPrefix: "pm",
      basicView: "PartTable",
    }
  },
  beforeRouteUpdate (to, from, next) {
    
    
    this.$store.dispatch("setView", to.params.view);
    
    next();
  },
  computed: {
    
    

  },
  watch: {
    
  },
  beforeCreate () {
    
    
    this.$store.dispatch("setView", "PartTable");
  },
  created() {
    this.$store.dispatch("showLoader", { visible: false, text: "" });
    this.$store.dispatch("setSectionPrefix", this.sectionPrefix)
  },
  methods: {
    
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PartManager/PartManager.vue